import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import ModalContainer from "../../../containers/Modal/ModalContainer";
import { TechAreaService } from "../../../services/TechAreaService";
export default function CreateOrEdit({ onClose, techAreaId, isOpen }) {
  const [errors, setErrors] = useState({});
  const [techArea, setTechArea] = useState({});
  let { t } = useTranslation();
  useEffect(() => {
    if (techAreaId)
      TechAreaService.getbyId(techAreaId).then((data) => {
        setTechArea(data);
      });
  }, [techAreaId]);
  function onChange({ target }) {
    setTechArea({ ...techArea, [target.name]: target.value });
  }
  function createOrUpdate() {
    if (validate()) return;
    TechAreaService.createOrUpdate(techArea).then((data) => {
      setTechArea({});
      onClose();
    });
  }
  function validate() {
    let errors = {};
    if (!techArea.description) errors.description = t("Required");
    setErrors(errors);
    return Object.keys(errors).length > 0;
  }

  return (
    <ModalContainer
      modalTitle={t("Create or Edit  Business Area")}
      onClose={onclose}
      submitButtonAction={createOrUpdate}
      submitButtonTitle={t("Save")}
      cancelButtonTitle={t("Cancel")}
      cancelButtonAction={onClose}
      submitButtonType="button"
      isOpen={isOpen}
    >
      <div className="form-group">
        <div className="label-wrapper">
          <label className="label">{t("Name")}</label>
          <div className="error-msg">{errors.description}</div>
        </div>
        <input
          onChange={onChange}
          className="form-control"
          name="description"
          value={techArea.description || ""}
        />
      </div>
    </ModalContainer>
  );
}
